module.exports = __webpack_public_path__ + "img/98ddce631bdde0014a840c1029884285.png";